export default __webpack_public_path__ + "static/brand-colors-mic-annotation-dark-a843c88ca9bd3ab49e151edb762c10e2.png";